// src/userService.js
// Helper for saving user preferences during onboarding
import { doc, setDoc } from "firebase/firestore";
import { db } from "./firebase";

export async function saveUserPreferences(uid, prefs) {
  if (!uid) return;
  const updates = {};
  if (prefs.stores) updates.enabledStores = prefs.stores;
  await setDoc(doc(db, "users", uid), updates, { merge: true });
}
